webpackJsonp([186263034317588],{

/***/ 375:
/***/ (function(module, exports) {

	module.exports = {"data":{"contentfulProject":{"title":"Ball in Net","createdAt":"August 17th, 2018","images":[{"file":{"url":"//images.ctfassets.net/td17hthlq11b/LANZqBrDe8cY0YGC8SWgg/87a81e5f3b5c25bac09a74174b954b69/1-combined.jpg"}},{"file":{"url":"//images.ctfassets.net/td17hthlq11b/5iuS7jf7A4yIk60ukooOoc/0a44fef90451a8ac627b7ba4abba399f/2-diagram.jpg"}},{"file":{"url":"//images.ctfassets.net/td17hthlq11b/4aPFSiKERW6EqKSQWqQsuO/f8b6324871194b7996d9b09b172c9aef/3-component.jpg"}},{"file":{"url":"//images.ctfassets.net/td17hthlq11b/G7FqnzU2g88u2SqAEUswQ/6a9abf1023e3eeeff269f8177282be9b/4-rendering.jpg"}},{"file":{"url":"//images.ctfassets.net/td17hthlq11b/5IhtRIwoYEKCwC4i2aE2sa/87047e0d31e9bf8a6e49076b6e2f40d1/6-ceremony.jpg"}}],"description":null}},"pathContext":{"slug":"ball-in-net"}}

/***/ })

});


// WEBPACK FOOTER //
// path---project-ball-in-net-b64a594ac5e77ce6e7e1.js